import { useCallback, useRef } from 'react';

export default function useKeyboardListFocus({ onEscape } = {}) {
  const inputRef = useRef();
  const listRef = useRef();

  const handleFocus = useCallback((diff) => {
    const list = [
      inputRef.current,
      ...(listRef.current?.children ?? []),
    ].filter((node) => node?.tabIndex >= 0);
    const focused = list.findIndex((node) => node === document.activeElement);
    let newFocus = (focused + diff) % list.length;
    if (newFocus === -1) newFocus = list.length - 1;

    list[newFocus].focus();
  }, []);

  const getOnKeyDown = useCallback(
    (onEnter) => (event) => {
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          return handleFocus(1);
        case 'ArrowUp':
          event.preventDefault();
          return handleFocus(-1);
        case 'Enter':
          event.preventDefault();
          return onEnter && onEnter();
        case 'Escape':
          return onEscape && onEscape();
        case 'Tab':
          return onEscape && onEscape();
        default:
          return null;
      }
    },
    [onEscape, handleFocus]
  );

  return { inputRef, listRef, getOnKeyDown };
}
